import request from '@/utils/request'

// 公告列表
export function bulletinListApi(data) {
  return request.get('/kfManage/bulletinList', { params: data })
}

// 客服列表
export function configListApi() {
  return request.get('/kfManage/configList')
}

// 官方频道
export function officialChannelListApi(paramsData) {
  return request.get('/kfManage/officialChannelList', { params: paramsData })
}

// 滚屏消息
export function scrollMsgListApi(data) {
  return request.get('/kfManage/scrollMsgList', { params: data })
}

// 消息列表
export function siteMessageListApi(data) {
  return request.post('/v1/siteMessage/list', data)
}

// 滚屏消息
export function sendMessageApi() {
  return request.get('/testBonus/testSendMessage')
}
